import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import models.LimitedTimeGameModes

/**
 * Local record of limited-time dice earned while a qualifying event was active.
 *
 * Earning is permanent, but use still requires current Banko Plus. If Plus lapses the skin locks;
 * when Plus renews, previously earned skins unlock again.
 */
object LimitedTimeDiceEntitlements {
    private var prefs: PlayerPreferences? = null
    private val mutableEarnedSkinIds = MutableStateFlow(emptySet<String>())
    val earnedSkinIds: StateFlow<Set<String>> = mutableEarnedSkinIds.asStateFlow()

    fun init(playerPreferences: PlayerPreferences) {
        prefs = playerPreferences
        mutableEarnedSkinIds.value = playerPreferences.getLimitedTimeDiceSkinUnlocks()
    }

    fun captureEligibleRewards(
        bankoPlusActive: Boolean,
        activeLimitedTimeSettingIds: Set<String> = LimitedTimeGameModes.activeSettingIdsNow(),
    ): Boolean {
        if (!bankoPlusActive || activeLimitedTimeSettingIds.isEmpty()) return false

        val newlyEarned = DiceSkin.entries
            .filter { it.tier == DiceSkinTier.LIMITED_PLUS }
            .filter { it.limitedTimeSettingId in activeLimitedTimeSettingIds }
            .mapTo(mutableSetOf()) { it.id }

        if (newlyEarned.isEmpty()) return false

        val updated = mutableEarnedSkinIds.value + newlyEarned
        if (updated == mutableEarnedSkinIds.value) return false

        mutableEarnedSkinIds.value = updated
        prefs?.setLimitedTimeDiceSkinUnlocks(updated)
        return true
    }
}
